<template>
  <div class="field">
    <label
      v-if="label"
      class="label"
      :for="inputId"
    >{{ label }}</label>
    <div class="control">
      <input
        :id="inputId"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
        class="input"
        :class="{ 'is-danger': hasError }"
        type="datetime-local"
      />
    </div>
    <p
      class="help is-danger"
      v-if="hasError"
    >{{ error[0] }}</p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"

/** A datetime input, may not be properly supported on all browsers */
export default defineComponent({
  props: {
    /** The input value */
    modelValue: String,
    /** Label for the field */
    label: String,
    /** Array of error messages */
    error: Object,
    /** ID assigned to the input if present, otherwise uses the label */
    htmlId: String
  },
  computed: {
    hasError() {
      return this.error !== undefined
    },
    inputId() {
      if (this.htmlId === undefined) {
        if (this.label === undefined) {
          return null
        }
        return this.label.replaceAll(" ", "-").toLowerCase()
      } else {
        return this.htmlId
      }
    }
  }
})
</script>